import { Injectable, isDevMode } from '@angular/core';
import { StorageService } from '../storage/storage.service';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { query } from '@angular/animations';

@Injectable({
  providedIn: 'root'
})
export class APIHelper {
  private _url: string;

  constructor(private http: HttpClient, private storage: StorageService) {
    this._url = environment.api;
  }

  requestApi({
    action,
    method = 'GET',
    datas = {},
  
    queryArgs = '',
    addFormat = true,
    httpParams = {}
  }: {
    action: string;
    method?: string;
    datas?: any;
   formData?:FormData;
    queryArgs?: string;
    addFormat?: boolean;
    httpParams?: any;
  }): Promise<any> {
    const methodWanted = method.toLowerCase();
    let urlToUse = this.url + action;

    const token = this.storage.getAsync({ key: 'token' });
    const bearer = this.storage.getAsync({ key: 'bearer' });

    if (addFormat) {
      let queryParams = '?format=json';

      if (token) {
        queryParams += '&alf_ticket=' + token;
      }

      if (queryArgs) {
        queryParams += '&' + queryArgs;
      }

      urlToUse += queryParams;
    }

    const headerObject = {
      // 'Content-Type': 'application/json',
     'Accept-Language':'*'
    };

    if (bearer) {
      headerObject['Authorization'] = 'Basic ' + bearer;
    }

    const httpOptions = {
      headers: new HttpHeaders(headerObject),
      ...httpParams
    };

    let req = null;

    if (methodWanted === 'post') {
      req = this.http.post(urlToUse, datas, httpOptions);
    } else if (methodWanted === 'put') {
      req = this.http.put(urlToUse, datas, httpOptions);
    } else if (methodWanted === 'delete') {
      req = this.http.delete(urlToUse, httpOptions);
    } else {
      req = this.http.get(urlToUse, httpOptions);
    }

    return req.toPromise().then(res => {
    
      if (res && res.entry) {
        return res.entry;
      } else {
        return res;
      }
    });
  }

  get url(): string {
    return this._url;
  }
}
